import { useMemo } from 'react';

import adminProductService from '@services/admin/productService';

/**
 * Admin Product Service Hook
 *
 * 簡單包裝 adminProductService，保持與 operator hook 的一致性。
 *
 * @example
 * const productService = useAdminProductService();
 *
 * await productService.create({ name: 'Product A', sku: 'SKU-001' });
 * await productService.checkSku('SKU-001');
 */
export function useAdminProductService() {
  return useMemo(() => adminProductService, []);
}
